/* eslint-disable import/prefer-default-export */
import { has } from "lodash";

export const isInnpakking = (orderLine) =>
  has(orderLine, "wcgwp_notes.for") && has(orderLine, "wcgwp_notes.notes");
